// PHONE NUMBER VALIDATION UTILITIES
import { parsePhone } from './parsePhone';
import { EXTENSION_PATTERNS } from './constants';

export interface ValidationResult {
  isValid: boolean;
  error?: string;
}

// VALIDATE A PHONE NUMBER
// - MUST BE PARSEABLE BY LIBPHONENUMBER-JS
// - MUST NOT CONTAIN EXTENSION PATTERNS
//
// `country` IS THE ASSUMPTION FOR INPUT WITHOUT A LEADING "+" (CU-86ajrx60c).
// WITHOUT IT, A NON-US NUMBER TYPED THE WAY THE PATIENT DIALS IT LOCALLY IS
// REPORTED AS "Invalid phone number" RATHER THAN PARSING CORRECTLY. OMITTING IT
// KEEPS THE EXISTING US DEFAULT, SO ALL CURRENT CALLERS ARE UNCHANGED.
export const validatePhone = (
  value: string | null | undefined,
  country?: string | null,
): ValidationResult => {
  // EMPTY IS VALID (USE YUP .required() FOR REQUIRED FIELDS)
  if (value === null || value === undefined || value === '') {
    return { isValid: true };
  }

  const trimmed = `${value}`.trim();
  if (!trimmed) {
    return { isValid: true };
  }

  // CHECK FOR EXTENSION PATTERNS
  if (EXTENSION_PATTERNS.test(trimmed)) {
    return {
      isValid: false,
      error: 'Phone number cannot contain extensions',
    };
  }

  // TRY TO PARSE
  const parsed = parsePhone(trimmed, country);

  if (!parsed) {
    return {
      isValid: false,
      error: 'Invalid phone number format',
    };
  }

  if (!parsed.isValid) {
    return {
      isValid: false,
      error: 'Invalid phone number',
    };
  }

  return { isValid: true };
};

// SIMPLE BOOLEAN CHECK FOR QUICK VALIDATION
export const isValidPhone = (
  value: string | null | undefined,
  country?: string | null,
): boolean => {
  return validatePhone(value, country).isValid;
};
